import React, { Component } from 'react'
import Header from '../components/Header.js'

class Home extends Component {

  render() {
    return (
      <Header />
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/pages/Home.js